import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-checkbox-type-five',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './checkbox-type-five.component.html',
  styleUrl: './checkbox-type-five.component.css',
})
export class CheckboxTypeFiveComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() visibleFields!: { [key: string]: boolean };
  @Input() requiredMap: { [key: string]: boolean } = {};
  @Output() visibilityChanged = new EventEmitter<{
    visibilityMap: { [key: string]: boolean };
    toggleField: string;
    skipTaskMappingDependency?: boolean;
  }>();
  selectedIds: string[] = [];
  showValidationError: boolean = false;
  requiredFields: any;
  @Output() handleTaskMappingDependency = new EventEmitter<{
    fieldName: string;
    tags: any[];
    selectedQuestion: any;
  }>();
  constructor() {}
  ngOnInit() {
    if (this.fields?.value === true || this.fields?.value == false) {
      this.control?.patchValue(this.fields.value, { emitEvent: false });
      const fieldName = this.resolveFieldName(this.fields);
      if (this.fields.value == true || fieldName === 'restorationTestType') {
        this.handleFieldDependencies();
      }
    }
    this.restoreTagsFromSelectedOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.initializeControl();
    }
  }

  initializeControl() {
    if (!this.fields) return;
    const currentValue = this.control?.value;
    if (currentValue === null || currentValue === undefined) {
      this.control?.setValue(this.fields.value === true, { emitEvent: false });
    }
    this.restoreTagsFromSelectedOptions();
    const fieldName = this.resolveFieldName(this.fields);
    if (
      this.control?.value === true ||
      this.fields.value == true ||
      fieldName === 'restorationTestType'
    ) {
      this.handleFieldDependencies();
    }
  }

  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  /** Function to handle dependencies on click of the switch */
  handleFieldDependencies(trigger?: boolean, options?: any) {
    const switchValue = this.formGroup.get(this.fields.fieldName)?.value;
    if (!this.fields.fieldDependencies) return;

    const visibilityMap: { [key: string]: boolean } = {};
    const toggledRequiredFields: string[] = [];

    this.fields.fieldDependencies.forEach((dependency: any) => {
      if (dependency.trigger === 'onValueChange') {
        // const conditionBlocks = Array.isArray(dependency.condition)
        //   ? dependency.condition
        //   : Array.isArray(dependency.conditions)
        //     ? dependency.conditions
        //     : [];

        dependency.condition.forEach((conditionBlock: any) => {
          const condition = conditionBlock.conditions[0];
          const fieldName = condition.value;
          const expectedValues = condition.equals;
          const actualValue = this.formGroup.get(fieldName)?.value;
          const conditionMatch = expectedValues.includes(actualValue);

          if (conditionMatch) {
            conditionBlock.actions.forEach((action: any) => {
              const targetField = action.targetField;
              const control = this.formGroup.get(targetField);

              visibilityMap[targetField] = action.value;

              if (control) {
                if (
                  action.actionType === 'isRequired' &&
                  action.value &&
                  switchValue === true
                ) {
                  control.setValidators([Validators.required]);
                  control.updateValueAndValidity({ emitEvent: false });

                  // Mark only this dependent field as touched
                  toggledRequiredFields.push(targetField);
                } else {
                  control.clearValidators();
                  control.updateValueAndValidity({ emitEvent: false });
                }
              }
            });
            // } else {
            //   dependency.condition.actions.forEach((action: any) => {
            //     const targetField = action.targetField;
            //     const control = this.formGroup.get(targetField);

            //     visibilityMap[targetField] = !action.value;

            //     if (control) {
            //       control.clearValidators();
            //       control.updateValueAndValidity({ emitEvent: false });
            //     }
            //   });
          }
        });
      }
    });

    //  Now actually mark touched only for toggled required fields
    toggledRequiredFields.forEach((fieldKey) => {
      const control = this.formGroup.get(fieldKey);
      control?.markAsTouched();
    });

    this.visibilityChanged.emit({
      visibilityMap,
      toggleField: this.fields.fieldName,
      skipTaskMappingDependency: options?.skipTaskMappingDependency,
    });
  }

  onToggle(event: any): void {
    const checked = event.target.checked;

    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');
    const fieldName = this.resolveFieldName(this.fields);
    let selectedQuestion = this.getQuestionLabel();
    if (selectedQuestion) {
      selectedQuestion = selectedQuestion
        .replace(/^\d+\.\s*/, '')
        .replace(/[^a-zA-Z0-9)\]\s]+$/, '')
        .trim();
    }

    this.control?.setValue(checked, { emitEvent: false });
    this.control?.markAsTouched();
    this.control?.updateValueAndValidity({ emitEvent: false });

    const tags = checked ? [true] : [false];
    tagsControl?.setValue(tags, { emitEvent: false });

    const skipMapping =
      this.fields?.formId === '68511e30c23e7a0f7ae5643d' &&
      fieldName === 'itTrainingField';

    this.handleFieldDependencies(true, { skipTaskMappingDependency: true });
    if (selectedQuestion && !skipMapping) {
      this.handleTaskMappingDependency.emit({
        fieldName,
        tags,
        selectedQuestion: selectedQuestion,
      });
    }
  }

  restoreTagsFromSelectedOptions(): void {
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');
    if (!this.control || !tagsControl) return;

    const checked = this.control.value === true || this.fields?.value === true;
    const fieldName = this.resolveFieldName(this.fields);
    let selectedQuestion = this.getQuestionLabel();
    if (selectedQuestion) {
      selectedQuestion = selectedQuestion
        .replace(/^\d+\.\s*/, '')
        .replace(/[^a-zA-Z0-9)\]\s]+$/, '')
        .trim();
    }

    const tags = checked ? [true] : [false];

    const skipMapping =
      this.fields?.formId === '68511e30c23e7a0f7ae5643d' &&
      fieldName === 'itTrainingField';

    tagsControl.setValue(tags, { emitEvent: false });
    if (!skipMapping) {
      this.handleTaskMappingDependency.emit({
        fieldName,
        tags,
        selectedQuestion: selectedQuestion,
      });
    }
  }

  private getQuestionLabel(): string {
    return (
      this.fields?.displayName ||
      this.fields?.label ||
      this.fields?.fieldName ||
      ''
    );
  }

  private resolveFieldName(field: any): string {
    if (!field) return '';

    // ✅ Case 1: direct string
    if (typeof field.fieldName === 'string') {
      return field.fieldName;
    }

    // ✅ Case 2: object { label, value }
    if (field.fieldName?.label) {
      return field.fieldName.label;
    }

    // ✅ Case 3: value[] format
    if (Array.isArray(field)) {
      return this.getValueByKey(field, 'fieldName') || '';
    }

    // ✅ Case 4: field.value is array (very common in your setup)
    if (Array.isArray(field.value)) {
      return this.getValueByKey(field.value, 'fieldName') || '';
    }

    return '';
  }

  private getValueByKey(arr: any[], key: string): any {
    return (arr || []).find((item: any) => item.Key === key)?.Value;
  }
}
